import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Projects", href: "/projects" },
  { label: "Process", href: "/process" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled || !isHome
            ? "bg-white border-b border-arch-border"
            : "bg-transparent"
        }`}
      >
        <div className="px-8 lg:px-14 py-5 flex items-center justify-between w-full">
          {/* Logo */}
          <Link to="/" className="flex items-center group cursor-pointer">
            <span
              className={`font-serif font-light tracking-[0.12em] text-xl transition-colors duration-300 ${
                scrolled || !isHome ? "text-arch-charcoal" : "text-white"
              }`}
            >
              STUDIO
            </span>
            <span
              className={`font-serif font-semibold tracking-[0.04em] text-xl ml-1 transition-colors duration-300 ${
                scrolled || !isHome ? "text-arch-charcoal" : "text-white"
              }`}
            >
              1323
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-xs tracking-[0.15em] uppercase font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.href
                    ? scrolled || !isHome
                      ? "text-arch-charcoal"
                      : "text-white"
                    : scrolled || !isHome
                    ? "text-arch-gray hover:text-arch-charcoal"
                    : "text-white/75 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA + Hamburger */}
          <div className="flex items-center gap-4">
            <Link
              to="/contact"
              className={`hidden lg:flex items-center px-5 py-2.5 text-xs tracking-[0.12em] uppercase font-medium transition-all duration-300 whitespace-nowrap rounded-md cursor-pointer ${
                scrolled || !isHome
                  ? "bg-arch-charcoal text-white hover:bg-arch-black"
                  : "bg-white text-arch-charcoal hover:bg-white/90"
              }`}
            >
              Request Consultation
            </Link>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className={`lg:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer`}
              aria-label="Toggle menu"
            >
              <span
                className={`block w-6 h-px transition-all duration-300 ${
                  scrolled || !isHome ? "bg-arch-charcoal" : "bg-white"
                } ${menuOpen ? "rotate-45 translate-y-2" : ""}`}
              />
              <span
                className={`block w-6 h-px transition-all duration-300 ${
                  scrolled || !isHome ? "bg-arch-charcoal" : "bg-white"
                } ${menuOpen ? "opacity-0" : ""}`}
              />
              <span
                className={`block w-6 h-px transition-all duration-300 ${
                  scrolled || !isHome ? "bg-arch-charcoal" : "bg-white"
                } ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`}
              />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-arch-charcoal transition-all duration-500 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-white font-serif text-3xl tracking-widest cursor-pointer hover:text-white/70 transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-6 px-8 py-3 border border-white text-white text-xs tracking-[0.15em] uppercase font-medium hover:bg-white hover:text-arch-charcoal transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request Consultation
          </Link>
        </div>
      </div>
    </>
  );
}
